import { Button, Box } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import { FilterType } from 'components/common/filter/Filter';
import LightbulbLineIcon from 'remixicon-react/LightbulbLineIcon';
import Filter2LineIcon from 'remixicon-react/Filter2LineIcon';
import { useLocation, useNavigate } from 'react-router-dom';
import { useBuildWiseModules } from '@buildwise/libs/helpers';

function NoProjectRetrospectives() {
  const theme = useTheme();
  const { pluralRetrospectivesModuleName } = useBuildWiseModules();

  return (
    <NoDataContainer>
      <LightbulbLineIcon size={120} color={theme.palette.custom.steel} />
      <NoDataDescription mb={1}>No {pluralRetrospectivesModuleName} Found</NoDataDescription>
    </NoDataContainer>
  );
}

const NoDataContainer = styled(Box, { label: 'NoDataContainer' })({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  margin: '40px 24px 0',
});

const NoDataTitle = styled(Box, { label: 'NoDataTitle' })(({ theme }) => ({
  fontSize: 16,
  fontWeight: 700,
  color: theme.palette.custom.tuna,
}));

const NoDataDescription = styled(Box, { label: 'NoDataDescription' })(({ theme }) => ({
  fontSize: 16,
  color: theme.palette.custom.mistBlue,
}));

export default NoProjectRetrospectives;
